var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultOffersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0384 10.4362L11.1634 2.56121C10.8484 2.24621 10.4109 2.05371 9.92969 2.05371H3.80469C2.84219 2.05371 2.05469 2.84121 2.05469 3.80371V9.92871C2.05469 10.41 2.24719 10.8475 2.57094 11.1712L10.4459 19.0462C10.7609 19.3612 11.1984 19.5537 11.6797 19.5537C12.1609 19.5537 12.5984 19.3612 12.9134 19.0375L19.0384 12.9125C19.3622 12.5975 19.5547 12.16 19.5547 11.6787C19.5547 11.1975 19.3534 10.7512 19.0384 10.4362ZM11.6797 17.8125L3.80469 9.92871V3.80371H9.92969V3.79496L17.8047 11.67L11.6797 17.8125Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99219 7.30371C6.71706 7.30371 7.30469 6.71608 7.30469 5.99121C7.30469 5.26634 6.71706 4.67871 5.99219 4.67871C5.26731 4.67871 4.67969 5.26634 4.67969 5.99121C4.67969 6.71608 5.26731 7.30371 5.99219 7.30371Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultOffersIcon);
export default __webpack_public_path__ + "static/media/default-offers-icon.e5191ddacc8e17b84b1d5b26d1e45427.svg";
export { ForwardRef as ReactComponent };